import { types } from 'mobx-state-tree';
import isEmpty from 'lodash/isEmpty';
import FinanceModel from './finance-model';

const UserDetailInfoModel = types.model({
  // 手机号是否绑定
  mobile_bind: false,
});

// enum UserPriv {
//   operator = 1,
//     star,
//     user,
//     service,
//     broker
// }

const GroupInfoModel = types.snapshotProcessor(
  types.model('GroupInfoModel', {
    group_level: 0,
    group_intimate_value: 0,
    guard_type: 0,
    guard_buy_type: 0,
    group_name: '',
  }),
  {
    preProcessor(snapshot) {
      const data = {};
      if (snapshot) {
        const { group_level, group_intimate_value, guard_type, guard_buy_type } = snapshot;
        if (group_level) {
          data.group_level = parseInt(group_level, 10);
        }
        if (group_intimate_value) {
          data.group_intimate_value = parseInt(group_intimate_value, 10);
        }
        if (guard_type) {
          data.guard_type = parseInt(guard_type, 10);
        }
        if (guard_buy_type) {
          data.guard_buy_type = parseInt(guard_buy_type, 10);
        }
      }

      return {
        ...snapshot,
        ...data,
      };
    },
  },
);

const DecoratorModel = types.snapshotProcessor(
  types.model('DecoratorModel', {
    ornaments_guard_first: 1,
    bubble_guard_first: 1,
    car_guard_first: 1,
    curr_ornaments: 0,
    curr_bubble: 0,
    curr_car: 0,
  }),
  {
    preProcessor(snapshot) {
      if (!isEmpty(snapshot)) {
        const { curr_ornaments, curr_bubble, curr_car } = snapshot;
        return {
          ...snapshot,
          curr_ornaments: parseInt(curr_ornaments, 10),
          curr_bubble: parseInt(curr_bubble, 10),
          curr_car: parseInt(curr_car, 10),
        };
      }
      return snapshot;
    },
  },
);

// todo: 注意 _id 与 family_id
const UserFamilyModel = types.model('UserFamilyModel', {
  _id: 0,
  family_id: 0,
  family_priv: 0,
  timestamp: 0,
  lastmodif: 0,
  family_name: '',
  badge_name: '',
  // "week_support":null
});

const UserStarModel = types.model('UserStarModel', {
  // 对应房间id
  room_id: 0,
  timestamp: 0,
  broker: 0,
});

const NobleModel = types.model('NobleModel', {
  // expire_at: '',
  level: 0,
  senior: false,
});

// 神秘人 相关的
const MysticModel = types.snapshotProcessor(
  types.model('MysticModel', {
    id: 0,
    nick_name: '',
    pic: '',
    gif: '',
    // 标签文本
    title: '',
    // 标签图片
    title_pic: '',
    expire_time: 0,
    open: false,
  }),
  {
    preProcessor(snapshot) {
      const data = {};
      if (snapshot) {
        const { gif } = snapshot;
        if (gif) {
          data.gif = gif;
        }
      }

      return {
        ...snapshot,
        ...data,
      };
    },
  },
);

// 用户充值信息
const PayLevelInfoModel = types
  .model('PayLevelInfoModel', {
    level: 0,
  })
  .views((self) => {
    return {
      get name() {
        return (
          ['黑铁', '青铜', '白银', '黄金', '铂金', '黑金', '钻石V1', '钻石V2', '钻石V3', '钻石V4'][
            self.level
          ] || '-'
        );
      },
    };
  });

const StarVipModel = types.model('StarVipModel', {
  type: 0,
});

const CategoryVerify = types.model('CategoryVerify', {
  name: '',
  pos_img: '',
  pos_txt: '',
  _id: 0,
});

const GuildInfoModel = types.model('GuildInfoModel', {
  guild_name: '',
  // guild_id: '',
});

const UserAttrsModel = types.model('UserAttrsModel', {
  family: types.maybeNull(UserFamilyModel),
  finance: FinanceModel,
  noble: types.maybeNull(NobleModel),
  is_24_hr_new_user: false,
  is_super_new_user: false,
  pay_level_info: types.optional(PayLevelInfoModel, {}),
  priv: 0,
  honor_fans: false,
});

const _UserModel = types
  .model('UserModel', {
    is_24_hr_new_user: false,
    is_super_new_user: false,
    // 用户id
    _id: types.identifierNumber,
    // 靓号
    mm_no: 0,
    // 靓号类型 1 2 3 4 ,值越大等级越高
    mm_no_price_type: 1,
    // 昵称
    nick_name: '',
    // 头像
    pic: '',
    // 用户身份  1:运营 2:主播 3:普通用户 4:客服 5:代理/经纪人/经纪人公会（叫法太多 哭。。）
    priv: 3, // types.enumeration<UserPriv>('Priv', Object.values(UserPriv)),
    finance: types.optional(FinanceModel, {}),
    // 主播排序  维C
    bean_rank: 0,
    // 用户排序  维C
    rank: 0,
    apply_type: 0,
    // 登录名
    user_name: '',
    address: '',
    // 手机号是否绑定
    mobile_bind: false,
    // detail_info: types.maybeNull(UserDetailInfoModel),
    email: '',
    // 进场新 背景
    enter_info_bg: 0,
    // 地址
    location: '',
    // 特权vip
    m_vip: 0,
    vip_hiding: 0,
    // vip
    vip: 0,
    sex: 0,
    // vip 过期时间戳
    vip_expires: 0,
    status: false,
    stature: 0,
    // 主播标签
    star_labels: types.maybeNull(types.array(types.string)),
    // 主播信息
    star: types.maybeNull(UserStarModel),
    // 主播游戏权限
    star_show_game: false,
    // 特殊主播
    special_star: false,
    // greeting_link_enabled: 0,
    // 银行信息验证
    bank_info_verify: 0,
    constellation: 0,
    family: types.maybeNull(UserFamilyModel),
    followers: 0, // 关注数
    identity_auth: false, // 身份认证状态
    // 经纪人 公会信息  ，在新的主播分成体系下 已废弃 fu 2021-09-07 10:46:16
    // "guild": {
    //   "guild_id": 20855613, // 经纪人公会id
    //   "guild_priv": 1, // 1: 公会长
    //   "timestamp": 0
    // },
    // //经纪人，
    // "broker": {
    //   "grade": 0 // 级别
    // },
    funny_star: false,
    noble: types.maybeNull(NobleModel),
    group_info: types.optional(GroupInfoModel, {}),
    coin_level: 0,
    week_spend: 0,
    admin: false,
    // 装扮信息
    decorator: types.optional(DecoratorModel, {}),
    // 神秘人信息
    mystic: types.optional(MysticModel, {}),
    // 星钻vip
    star_vip: types.optional(StarVipModel, {}),
    // 主播星级
    star_level: 3,
    category_verify: types.optional(CategoryVerify, {}),
    guild_info: types.optional(GuildInfoModel, {}),
    // 用户充值等级
    pay_level_info: types.optional(PayLevelInfoModel, {}),
    // 炫彩昵称
    colourful_name: false,
    // 是否是荣耀粉丝
    honor_fans: false,
    // 是否可以现金提现
    cash_apply_available: false,
    // 幸运大咖
    lucky_star: false,
    // 是否需要，人脸识别
    live_bio_verify: false,

    // packet_name, app_type 用来区分游趣包
    packet_name: '',
    app_type: '',

    // 信用分
    credit_score: 0,
    // 主播是否禁播
    ban: false,
    // 主播解禁时间
    unban_time: 0,

    // 停播天数
    terminal_last_live_days: 0,
  })
  .views((self) => {
    return {
      get isAnchor() {
        return self.priv === 2;
      },
      get isStar() {
        return self.priv === 2;
      },
      get isService() {
        return self.priv === 4;
      },
      get isBroker() {
        return self.priv === 5;
      },
      get isOperate() {
        return self.priv === 1;
      },
      get isVip() {
        return self.vip !== 0;
      },
      get isEnableVipHiding() {
        return self.finance.richData.level > 9 && self.isVip;
      },
      get isOpenMystic() {
        return self.mystic.open;
      },
      get gif() {
        return this.isOpenMystic ? self.mystic.gif : '';
      },
    };
  })
  .actions((self) => {
    const setLivBioVerify = (toggle = false) => {
      self.live_bio_verify = toggle;
    };

    return {
      setLivBioVerify,
    };
  });

const snapshotProcessor = (userModel) => {
  return types.snapshotProcessor(userModel, {
    preProcessor(snapshot) {
      const data = {};
      if (snapshot) {
        const { uid, pic_url, mm_no, noble, nickname, mystic, unban_time, ban } = snapshot;

        if (uid) {
          data._id = uid;
        }
        if (pic_url) {
          data.pic = pic_url;
        }
        if (nickname) {
          data.nick_name = nickname;
        }
        // if (mm_no) {
        //   data.mm_no = `${mm_no}`;
        // }

        if (mystic === null) {
          data.mystic = {};
        }
        if (unban_time === null) {
          data.unban_time = 0;
        }

        if (ban === null) {
          data.ban = false;
        }

        if (noble) {
          data.noble = noble;
          const { senior, level } = noble;
          data.noble.senior = senior === 'true';
          data.noble.level = parseInt(level, 10);
        }
      }
      return {
        ...snapshot,
        ...data,
      };
    },
  });
};

const UserModel = snapshotProcessor(_UserModel);

const extendUserModel = (name, props) => {
  return snapshotProcessor(_UserModel.named(name).props(props));
};

export default UserModel;

export {
  extendUserModel,
  UserDetailInfoModel,
  UserStarModel,
  UserFamilyModel,
  NobleModel,
  PayLevelInfoModel,
  UserAttrsModel,
  MysticModel,
};
